import React, { PureComponent } from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  TooltipFormatter,
  LabelFormatter,
} from 'recharts';
import chartStyles from '../../../../styles/charts.module.scss';
import { DetailedStream } from '../../../../types';
import { FormattedNumber, injectIntl, IntlShape, defineMessages } from 'react-intl';

type Props = {
  startsStreams: DetailedStream[];
  intl: IntlShape;
};

class InternationalizedStartsStreams extends PureComponent<Props> {
  toolTipFormatter: TooltipFormatter =
    /* istanbul ignore next */
    (value, key, { color }) => {
      return (
        <div>
          <span
            className={chartStyles['audience-tooltip-circle']}
            style={{ backgroundColor: color }}
          />
          <span className={chartStyles['audience-tooltip-label']}>{key}</span>
          <span className={chartStyles['audience-tooltip-value']}>
            <FormattedNumber value={value as number} />
          </span>
        </div>
      );
    };

  formatLabel: LabelFormatter =
    /* istanbul ignore next */
    label => {
      return this.props.intl
        .formatDate(new Date(label), {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          timeZone: 'UTC',
        })
        .toUpperCase();
    };

  formatXAxisTick: LabelFormatter = label =>
    this.props.intl
      .formatDate(new Date(label), {
        day: 'numeric',
        month: 'short',
        year: undefined,
        timeZone: 'UTC',
      })
      .toUpperCase();

  formatYAxisTick: LabelFormatter = label =>
    this.props.intl
      .formatNumber(label as number, {
        notation: 'compact',
        maximumSignificantDigits: 3,
      })
      .toLowerCase();

  render() {
    const startsStreamsMessages = defineMessages({
      starts: {
        id: 'network.audience.starts-streams.tooltip-starts',
        defaultMessage: 'Starts',
      },
      streams: {
        id: 'network.audience.starts-streams.tooltip-streams',
        defaultMessage: 'Streams',
      },
    });

    return (
      <div data-qa="starts-and-streams-chart" style={{ width: '100%', height: '350px' }}>
        <ResponsiveContainer height={350}>
          <AreaChart
            className={chartStyles.chart}
            data={this.props.startsStreams}
            margin={{ top: 15, right: 10, left: -20, bottom: 0 }}
          >
            <XAxis
              axisLine={false}
              dataKey="date"
              tickFormatter={this.formatXAxisTick}
              tickLine={false}
            />
            <YAxis axisLine={false} tickFormatter={this.formatYAxisTick} tickLine={false} />
            <CartesianGrid vertical={false} />
            <Tooltip
              isAnimationActive={false}
              itemStyle={{ color: 'unset', padding: '4px 0' }}
              wrapperStyle={{
                borderRadius: '5px',
                boxShadow: '0 3px 8px 0 rgba(0, 0, 0, 0.2)',
                borderColor: 'white',
              }}
              formatter={this.toolTipFormatter}
              labelFormatter={this.formatLabel}
              separator=" "
            />
            <Area
              type="linear"
              dataKey="starts"
              name={this.props.intl.formatMessage(startsStreamsMessages.starts)}
              stackId="1"
              stroke="#fec86b"
              fill="#fee3b5"
              strokeWidth={2}
              activeDot={{ strokeWidth: 3, r: 7 }}
              isAnimationActive={false}
            />
            <Area
              type="linear"
              dataKey="streams"
              name={this.props.intl.formatMessage(startsStreamsMessages.streams)}
              stackId="2"
              stroke="#fd4738"
              fill="#fea39b"
              strokeWidth={2}
              activeDot={{ strokeWidth: 3, r: 7 }}
              isAnimationActive={false}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

const StartsStreams = injectIntl(InternationalizedStartsStreams);
export { StartsStreams };
